//=> Import React
import React from "react";

//=> Import plugins
import { useStaticQuery, graphql } from "gatsby"
import ReactMarkdown from "react-markdown";
//=> Import plugins

//=> Import Styles
import { article } from "./styles.module.scss"


//=> Component
const InfoBanner = () => {

  // Requêtes Bannière info
  const data = useStaticQuery(graphql`
   query {
  strapiInfo {
    description
    updatedAt
  }
}
  `)
  // Variable pour la description du champ info
  let infoBanner = ""

  // Si il y a une info je la stock dans la variable infoBanner
  if (data.strapiInfo) infoBanner = data.strapiInfo.description

  // Sinon je retourne null
  if (infoBanner === "") return null

  //=> Component
  return (

    <article className={article}>
      <ReactMarkdown children={infoBanner} />
    </article>


  )
}

export default InfoBanner
